import { Button, Stack, Typography } from '@mui/material';
import { StepPaper } from './StepPaper.js';
import type { WizardStepProps } from './WizardRouter.js';

export const Step1Welcome = ({ onAdvance }: WizardStepProps) => (
  <StepPaper>
    <Stack spacing={3}>
      <Typography variant="h3">Get started with ScriptPad</Typography>

      <Typography variant="body1">
        Congratulations - you're about to have access to the simplest, standalone electronic prescribing
        platform in Australia.
      </Typography>

      <Typography variant="body1" color="text.secondary">
        Before we get started, we need to verify your identity and how you will onboard with ScriptPad. We
        take security and identity very seriously to ensure the safety of Australia's electronic
        prescribing network, so we very much appreciate your cooperation, but don't worry - the process
        is generally quick and easy.
      </Typography>

      <Stack
        direction={{ xs: 'column-reverse', sm: 'row' }}
        spacing={{ xs: 1.5, sm: 2 }}
        sx={{ pt: 2 }}
      >
        <Button size="large" variant="contained" onClick={() => onAdvance(2)}>
          Get started
        </Button>
      </Stack>
    </Stack>
  </StepPaper>
);
